import React from "react";
import Stack from "../../../../components/lib/Stack";
import Text from "../../../../components/lib/Text";
import { SimpleLink } from "../../../../components/lib/Link";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// @ts-ignore
import NonIdealState from "../../../job_library/components/NonIdealState";
// @ts-ignore
import excelTemplateHref from "../../../../assets/templates/create_user_data.xls";
// @ts-ignore
import csvTemplateHref from "../../../../assets/templates/create_user_data.csv";
import ViewFailedItem from "./ViewFailedItem";
import { useUploadUserContext } from "../context/UploadUserContext";

import { useFileDropzone } from "../context/useFileDropzone";
import Button from "../../../../components/lib/Button";
import Box from "../../../../components/lib/Box";

const dropzoneProps: any = {
  borderWidth: "1px",
  borderRadius: "base",
  borderColor: "$primaryLight",
  backgroundColor: "$primaryLightest",
  borderStyle: "dashed",
  padding: "$8",
  minHeight: "$52",
  alignItems: "center",
  justifyContent: "center",
  // a11y
  role: "region",
  "aria-live": "polite",
  "aria-describedby": "drop-instructions",
};

const UploadFile = () => {
  const { response, uploadUsers, resetData } = useUploadUserContext();
  const dropzone = useFileDropzone({
    fileUploadCallback: async ({ file, setStatus }) => {
      await uploadUsers(file);
      setStatus("idle");
    },
    accptedFileTypes: {
      "text/csv": [".csv"],
      "application/vnd.ms-excel": [".xls"],
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
    },
  });

  if (dropzone.status === "idle") {
    dropzoneProps.backgroundColor = "$primaryLightest";
    dropzoneProps.borderColor = "$primary";
  }

  if (dropzone.status === "dragging") {
    dropzoneProps.backgroundColor = "$brandLightest";
    dropzoneProps.borderColor = "$primary";
  }

  if (dropzone.status === "error" || dropzone.status === "formatError") {
    dropzoneProps.backgroundColor = "$dangerLightest";
    dropzoneProps.borderColor = "$danger";
  }

  return (
    <Stack css={{ width: "$full", padding: "20px" }}>
      <Stack css={{ width: "$full", flexFlow: "row", justifyContent: "center" }}>
        <Stack css={{ ...dropzoneProps }} fill {...dropzone.containerProps}>
          <input
            type="file"
            accept=".csv,.xls,.xlsx"
            name="csv"
            {...dropzone.inputProps}
            style={{ display: "none" }}
          />

          <Stack
            fill
            nogap
            css={{
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {dropzone.status === "loading" && (
              <NonIdealState
                icon="circle-notch"
                iconClasses="fa-spin"
                title="Loading"
                description="Please wait while data it's being transferred."
              />
            )}

            {dropzone.status !== "loading" && (
              <>
                <FontAwesomeIcon icon="download" fixedWidth className="icon" />
                {dropzone.status === "dragging" && (
                  <Text as="p" css={{ marginTop: "10px" }}>
                    Drop your files here ...
                  </Text>
                )}
                {dropzone.status === "idle" && (
                  <Text as="p" css={{ marginTop: "10px" }}>
                    Click to upload or drag & drop CSV/XLS file here
                  </Text>
                )}

                {dropzone.status === "formatError" && (
                  <Text as="p" css={{ marginTop: "10px" }}>
                    Invalid file format. Please upload a valid CSV/XLS file.
                  </Text>
                )}

                <Box css={{ marginTop: 0, marginBottom: 0 }}>
                  <Button
                    icon="file-excel"
                    // icon={<DocumentsIcon />}
                    onClick={dropzone.triggerFileInpuClick}
                    disabled={dropzone.status === "dragging"}
                  >
                    Select CSV/XLS File
                  </Button>
                </Box>
              </>
            )}
          </Stack>
        </Stack>
      </Stack>

      <Stack
        css={{
          width: "$full",
          marginTop: "20px",
          alignItems: "flex-start",
          fontSize: "14px",
          flexFlow: "row",
        }}
      >
        <SimpleLink href={excelTemplateHref} download>
          Sample user xls template
        </SimpleLink>
        <SimpleLink href={csvTemplateHref} download>
          Sample user csv template
        </SimpleLink>
        <div style={{ marginLeft: "auto" }}>
          {dropzone.status !== "loading" &&
            (response?.rejected_data?.length > 0 ||
              response?.already_exists?.length > 0) && (
              <Button
                color="brand"
                size="normal"
                onClick={resetData}
                css={{ justifyContent: "right", marginRight: "10px" }}
              >
                Reset Data
              </Button>
            )}
        </div>
      </Stack>
      {dropzone.status !== "loading" && response?.rejected_data?.length > 0 && (
        <div
          style={{
            width: "100%",
            marginTop: "30px",
            marginBottom: "30px",
            padding: "20px",
            backgroundColor: "#f9f9f9",
            borderRadius: "8px",
            border: "1px solid #e0e0e0",
          }}
        >
          <Stack css={{ width: "$full", marginTop: "20px" }}>
            <Stack nogap css={{ width: "$full", alignItems: "flex-start" }}>
              <Text as="h4" noMargin>
                Records Failed to Upload
              </Text>
              <Text color="primary">
                These records face some error during upload. Please click on i button for
                more info
              </Text>
            </Stack>
            <ViewFailedItem keyType="rejected_data" />
          </Stack>
        </div>
      )}
      {dropzone.status !== "loading" && response?.already_exists?.length > 0 && (
        <div
          style={{
            width: "100%",
            marginTop: "30px",
            marginBottom: "30px",
            padding: "20px",
            backgroundColor: "#f9f9f9",
            borderRadius: "8px",
            border: "1px solid #e0e0e0",
          }}
        >
          <Stack css={{ width: "$full", marginTop: "20px" }}>
            <Stack nogap css={{ width: "$full", alignItems: "flex-start" }}>
              <Text as="h4" noMargin>
                Already Existing Username or Email
              </Text>
              <Text color="primary">
                The data presented on this table is across all experience levels.
              </Text>
            </Stack>
            <ViewFailedItem keyType="already_exists" />
          </Stack>
        </div>
      )}
    </Stack>
  );
};

export default UploadFile;
